import PropTypes from "prop-types";
import { Avatar } from "../ui";

const PaymentMethodHeader = ({ merchant, pricing, onBack }) => {
  return (
    <>
      <div className="flex items-center gap-3 mb-6 sm:mb-8">
        <button
          onClick={onBack}
          className="p-1 rounded-lg hover:bg-gray-100 transition-colors"
          style={{ color: "#515164" }}
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <Avatar
          name={merchant?.name}
          imageUrl={merchant?.logo_url}
          size="md"
        />
        <h1 className="text-base sm:text-lg font-bold" style={{ color: "#3B3B3B" }}>
          {merchant?.name || "Payment"}
        </h1>
      </div>

      <div className="mb-4 sm:mb-6">
        <h2 className="text-xl sm:text-2xl font-bold mb-1" style={{ color: "#3B3B3B" }}>
          Choose Payment Method
        </h2>
        <p className="text-xs sm:text-sm" style={{ color: "#515164" }}>
          Choose Payment Method to Continue Payment
        </p>
      </div>
    </>
  );
};

PaymentMethodHeader.propTypes = {
  merchant: PropTypes.object,
  pricing: PropTypes.object,
  onBack: PropTypes.func.isRequired,
};

export default PaymentMethodHeader;
